var render = function render(){var _vm=this,_c=_vm._self._c;return _c('product-scenarios',{attrs:{"value":_vm.adaptedValue,"is-mop":_vm.isMop,"product-type":_vm.productTypeSentinel,"rts-version":_vm.rtsVersionSentinel,"period1-captions":_vm.period1Captions,"compact-scenarios":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }